
import naja from "naja";
import { md5 } from 'js-md5';
import onDomReady from "@/global/js/onDomReady";

function init() {
    const buttonEl = document.getElementById("bookAdemo");
    const url = buttonEl.dataset.url + "?code=" + md5(buttonEl.dataset.code);
    const anchorEl = document.createElement("a");

    anchorEl.href = url;
    anchorEl.target = "_blank";
    anchorEl.textContent = buttonEl.textContent;
    anchorEl.className = buttonEl.className;

    buttonEl.parentNode.replaceChild(anchorEl, buttonEl);
}

export default {
	init,
}
